import has from 'lodash/has';
import {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ICONS from './icon-defs';

export default class Icon extends Component {
    static propTypes = {
        /** Additional class(es) to add to the component. */
        className: PropTypes.string,
        /** The name of the icon to display from the icons map. */
        name: PropTypes.string.isRequired,
        /** The ARIA role attribute. */
        role: PropTypes.string,
        /** The dimensions to set the width and height of the icon to. */
        size: PropTypes.number,
        /** Additional key/value pairs for the icon names/path definitions to add on to the common set provided. */
        iconDefinitions: PropTypes.object,
    };
    static defaultProps = {
        role: 'presentation',
        size: 20,
    };

    constructor(props) {
        super(props);

        const {name, iconDefinitions} = props;

        this._ICONS = {
            ...ICONS,
            ...iconDefinitions,
        };

        if (!has(this._ICONS, name)) {
            throw new Error(
                `'${name}' is not a valid icon name. Please use a defined name from the icon definitions available.`
            );
        }
    }

    render() {
        const {className, name, role, size} = this.props;
        const classes = classNames('Icon', `Icon-${name}`, className);

        return (
            <svg
                className={classes}
                role={role}
                viewBox="0 0 1024 1024"
                width={`${size}px`}
                height={`${size}px`}
            >
                <path d={this._ICONS[name]} />
            </svg>
        );
    }
}
